import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@mui/material';
import ActionDelete from '@mui/icons-material/Delete';
import clsx from 'clsx';
import { useTranslate, useDeleteWithUndoController, useRecordContext, useResourceContext, } from 'react-admin';
export var DeleteWithUndoIconButton = function (props) {
    var className = props.className, _a = props.label, label = _a === void 0 ? 'ra.action.delete' : _a, _b = props.redirect, redirectTo = _b === void 0 ? 'list' : _b, mutationOptions = props.mutationOptions;
    var record = useRecordContext(props);
    var resource = useResourceContext(props);
    var _c = useDeleteWithUndoController({
        mutationOptions: mutationOptions,
        resource: resource,
        record: record,
        redirect: redirectTo,
    }), isPending = _c.isPending, handleDelete = _c.handleDelete;
    var translate = useTranslate();
    var translatedLabel = translate(label, { _: label });
    return (_jsx(Tooltip, { title: translatedLabel, children: _jsx(IconButton, { "aria-label": translatedLabel, disabled: isPending, onClick: handleDelete, className: clsx('ra-delete-button', className), size: "small", children: _jsx(ActionDelete, { color: "error" }) }, "button") }));
};
